import { BookOpen, Command, Moon, RadioTower, Search, Sun } from 'lucide-react';
import { useSettingsStore } from '@/stores/settingsStore';
import { useUiStore } from '@/stores/uiStore';
import { useResolvedTheme } from '@/hooks/useTheme';

/** Top-most bar: app identity, search / command palette entry points, and the theme toggle. */
export function TitleBar() {
  const openPalette = useUiStore((state) => state.openPalette);
  const openEducationCenter = useUiStore((state) => state.openEducationCenter);
  const resolvedTheme = useResolvedTheme();
  const setThemeMode = useSettingsStore((state) => state.setThemeMode);

  return (
    <div
      className="flex items-center gap-3 border-b border-border bg-surface px-3 text-sm"
      style={{ height: 'var(--toolbar-height)' }}
    >
      <div className="flex items-center gap-2 font-semibold text-text">
        <RadioTower className="h-4 w-4 text-accent" aria-hidden />
        Trajectory GUI
      </div>

      <div className="flex-1" />

      <button
        type="button"
        onClick={() => openEducationCenter()}
        title="Open learning centre, aerospace glossary, workflows, and model guidance"
        aria-label="Open learning and reference centre"
        className="flex items-center gap-1.5 rounded-control border border-info/30 bg-info/5 px-2 py-1 text-xs text-info hover:bg-info/10"
      >
        <BookOpen className="h-3.5 w-3.5" />
        <span className="hidden min-[860px]:inline">Learn</span>
      </button>

      <button
        type="button"
        onClick={() => openPalette('panels')}
        aria-label="Go to a panel"
        className="flex items-center gap-2 rounded-control border border-border px-2 py-1 text-xs text-muted hover:text-text"
      >
        <Search className="h-3.5 w-3.5" />
        Go to panel
        <kbd className="rounded-control bg-surface-sunken px-1 text-faint">Ctrl P</kbd>
      </button>

      <button
        type="button"
        onClick={() => openPalette('commands')}
        aria-label="Open command palette"
        className="flex items-center gap-2 rounded-control border border-border px-2 py-1 text-xs text-muted hover:text-text"
      >
        <Command className="h-3.5 w-3.5" />
        Commands
        <kbd className="rounded-control bg-surface-sunken px-1 text-faint">Ctrl K</kbd>
      </button>

      <button
        type="button"
        onClick={() => setThemeMode(resolvedTheme === 'dark' ? 'light' : 'dark')}
        title="Toggle theme"
        aria-label={`Switch to ${resolvedTheme === 'dark' ? 'light' : 'dark'} theme`}
        className="flex h-7 w-7 items-center justify-center rounded-control text-muted hover:bg-surface-sunken hover:text-text"
      >
        {resolvedTheme === 'dark' ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
      </button>
    </div>
  );
}
